import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      title: 'Web Development',
      description: 'Building responsive, fast, and scalable web applications with modern frameworks and AI integration.',
      features: ['React & Next.js Apps', 'AI-Powered Features', 'Performance Optimization', 'Modern UI/UX']
    },
    {
      title: 'Mobile Development',
      description: 'Creating cross-platform mobile apps with React Native, delivering native performance and experience.',
      features: ['iOS & Android Apps', 'Cross-platform Solutions', 'App Store Deployment', 'Native Performance']
    },
    {
      title: 'AI Integration',
      description: 'Implementing cutting-edge AI solutions including LangChain, RAG systems, and intelligent automation.',
      features: ['LangChain Development', 'RAG Systems', 'Agentic AI Solutions', 'OpenAI Integration']
    },
    {
      title: 'Full Stack Solutions',
      description: 'End-to-end development from database design to cloud deployment with scalable architecture.',
      features: ['API Development', 'Database Design', 'Cloud Deployment', 'Microservices']
    }
  ];

  return (
    <section className="services-updated">
      {/* Background Effects */}
      <div className="services__background">
        <div className="background-shapes">
          <div className="bg-shape bg-shape--1"></div>
          <div className="bg-shape bg-shape--2"></div>
          <div className="bg-shape bg-shape--3"></div>
        </div>
      </div>

      <div className="container">
        <div className="section__header">
          <div className="section__badge">
            <span>💼</span>
            <span>Services</span>
          </div>
          
          <h2 className="section__title">
            What I <span className="text--accent">Specialize In</span>
          </h2>
          
          <p className="section__description">
            Comprehensive digital solutions that combine beautiful design with powerful functionality and AI innovation.
          </p>
        </div>

        <div className="services__grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="card__content">
                <h3 className="card__title">{service.title}</h3>
                <p className="card__description">{service.description}</p>
                
                <div className="card__features">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
              
              <div className="card__hover-effect"></div>
            </div>
          ))}
        </div>

        <div className="services__cta">
          <p className="cta__text">
            Ready to transform your ideas into reality? 
            <span className="cta__highlight"> Let's build something amazing together.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;